module.exports = __webpack_public_path__ + "img/theater-category.d8f245e9.png";